// extracted by mini-css-extract-plugin
export default {"switch":"Style_switch__tUy+u","slider":"Style_slider__MBrKX"};